import { APIError } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useApplication } from "../../../ApplicationContext";
import { useApplicationFormContext } from "../../../ApplicationFormContext";
import { OneIdLayoutContext } from "../../../layouts/OneIdLayoutContext";
import { updateSection, useHandleChange } from "../../../utils";

export function useNonBiometricIdOptOutHandler() {
  const { caseId } = useApplicationFormContext();
  const { basePath } = useApplication();
  const { optedOutOfNonBiometricId } = useContext(OneIdLayoutContext);
  const { t } = useTranslation();

  const handleChange = useHandleChange();

  const changeNonBiometricIdOptOut = async (
    opt_out_reason: string,
    other_reason: string
  ) => {
    const updatedData = {
      non_biometric_id_verification_opt_out: {
        opt_out_value: !optedOutOfNonBiometricId,
        opt_out_reason,
        other_reason,
      },
    };
    try {
      await updateSection(caseId, updatedData, "one-id", false, basePath);
      handleChange(
        "non_biometric_id_verification_opt_out",
        updatedData.non_biometric_id_verification_opt_out
      );
    } catch (e) {
      if (e instanceof APIError) {
        showToast(t("Something went wrong, try again"), { type: "error" });
      }
    }
  };
  return changeNonBiometricIdOptOut;
}
